export const selectLoading = (state) => Boolean(state.user.loading);
export const selectUpdating = (state) => state.user.updating;
export const selectChangingPassword = (state) => state.user.changingPassword;
export const selectLoggedIn = (state) => state.user.loggedIn;
export const selectError = (state) => state.user.error;
export const selectDetails = (state) => state.user.details;
export const selectCustomerId = (state) => state.user.details?.uid;

export const selectPasswordResetStatus = (state) => state.user.passwordResetStatus;
export const selectPasswordSetStatus = (state) => state.user.passwordSetStatus;
